import { useEffect, useState } from "react";

// A plain HH:MM text box instead of <input type="time">: Safari fills an empty time input
// with a grey "12:30" that looks like a real value. onChange only ever gets a complete
// "HH:mm" or "" - a half-typed time stays local until it's finished or the box loses focus.

const toTime = (digits) => {
    if (!digits) return "";
    // "9" -> 09:00, "93" -> 93 is not an hour so 09:30, "930" -> 09:30, "0930" -> 09:30
    let h, m;
    if (digits.length <= 2 && Number(digits) <= 23) { h = digits; m = "00"; }
    else if (digits.length === 2) { h = digits[0]; m = digits[1] + "0"; }
    else if (digits.length === 3) { h = digits[0]; m = digits.slice(1); }
    else { h = digits.slice(0, 2); m = digits.slice(2, 4); }
    if (Number(h) > 23 || Number(m) > 59) return "";
    return h.padStart(2, "0") + ":" + m.padEnd(2, "0");
};

const mask = (digits) => digits.length > 2 ? digits.slice(0, 2) + ":" + digits.slice(2) : digits;

export const TimeTextInput = ({ value, onChange, className, style, placeholder = "HH:MM" }) => {
    const [draft, setDraft] = useState(value || "");

    useEffect(() => { setDraft(value || ""); }, [value]);

    const handleChange = (e) => {
        const digits = e.target.value.replace(/\D/g, "").slice(0, 4);
        setDraft(mask(digits));
        if (digits.length === 4) {
            const time = toTime(digits);
            if (time) onChange(time);
        } else if (!digits && value) {
            onChange("");
        }
    };

    const handleBlur = () => {
        const time = toTime(draft.replace(/\D/g, ""));
        setDraft(time);
        if (time !== (value || "")) onChange(time);
    };

    return (
        <input
            type="text"
            inputMode="numeric"
            maxLength={5}
            className={className}
            style={style}
            placeholder={placeholder}
            value={draft}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
};
